import { getOSM } from '../OverworldAnimation.js';

export default class Drawable {
    serialize() {
        console.log(`Serializing ${this.constructor.name}`);
        return {
            position: this.position,
        };
    }

    static deserialize(data) {
        return new Drawable({ position: data.position });
    }

    constructor({
        position = {
            x: 0,
            y: 0,
            z: 0,
        },
    } = {}) {
        this.position = position;
        this.animationOffset = {
            x: 0,
            y: 0
        }
        this.OSM = getOSM();
    }

    effectiveX() {
        return this.position.x + this.xModifier;
    }

    effectiveY() {
        return this.position.y + this.yModifier;
    }

    move(xDistance, yDistance) {
        this.animationOffset.x = xDistance
        this.animationOffset.y = yDistance
    }

    effectivePosition() {
        if (this.OSM === null || this.OSM === undefined) {
            console.warn('OSM not defined for this drawable.');
            return {
                x: 0,
                y: 0,
            };
        }
        return {
            x: this.position.x + this.OSM.GUI.playerXOffset,
            y: this.position.y + this.OSM.GUI.playerYOffset,
        };
    }

    fadeOut() {
        
    }

    draw() {
        throw new Error('You must implement the draw() method');
    }

    static blackBarColor = 'rgba(100, 100, 100, 1)';

    static greenBarColor = 'rgba(120, 245, 180, 1)';
    static greenBarShadow = 'rgba(60, 123, 90, 0.5)';

    static yellowBarColor = 'rgba(225, 225, 80, 1)';
    static yellowBarShadow = 'rgba(0, 0, 0, 0.25)';

    static redBarColor = 'rgba(245, 100, 100, 1)';
    static redBarShadow = 'rgba(0, 0, 0, 0.25)';

    static blueBarColor = 'rgba(80, 160, 255, 1)';
}
